import { IApplicationAsset } from '@kurtosys/ksys-api-client/dist/models/requests/applicationManager/IApplicationAsset';
import { BaseStore } from './BaseStore';
import { observable, action, isArrayLike } from 'mobx';
import { Services } from '../services';
import { getApplicationCode } from '../index';
import { DataStore } from './DataStore';
import { Stores } from '../models/Stores';
import { appendCacheQueryString } from '@kurtosys/ksys-app-template/dist/appsManager/utils';

export interface AssetsByFileName {
    [fileName: string]: IApplicationAsset;
}

export class AssetStore extends BaseStore {
    @observable.ref
    assets: Array<IApplicationAsset>;
    assetsByFileName: AssetsByFileName;
    constructor(stores: Stores, public dataStore: DataStore) {
        super(stores);
    }
    async init() {
        await this.getAssets();
    }

    get services(): Services {
        return this.dataStore && this.dataStore.services;
    }

    get applicationCode(): string {
        return getApplicationCode();
    }

    get apiUrl(): string {
        return this.dataStore.apiUrl;
    }

    @action
    async getAssets() {
        try {
            if (this.services) {
                const assetsResponse = await this.services.getListAssets({
                    applicationCode: this.applicationCode,
                });
                this.assets =
                    assetsResponse && assetsResponse.applicationAssets;
                if (this.assets && isArrayLike(this.assets)) {
                    this.assetsByFileName = this.assets.reduce(
                        (acc: AssetsByFileName, asset) => {
                            acc[asset.fileName] = asset;
                            return acc;
                        },
                        {}
                    );
                }
            } else {
                console.warn('Services is undefined on AssetStore');
            }
        } catch (e) {
            console.warn(e);
        }
    }

    getAssetUrl(fileName: string) {
        const asset = this.assetsByFileName && this.assetsByFileName[fileName];
        const cacheOptions =
            // asset &&
            this.dataStore &&
            this.dataStore.config &&
            this.dataStore.config.globalConfig &&
            this.dataStore.config.globalConfig.cacheOptions;
        return `${this.apiUrl}/${appendCacheQueryString(
            fileName,
            asset as any,
            cacheOptions
        )}`;
    }
}



// WEBPACK FOOTER //
// ./src/stores/AssetStore.ts